import { routeName } from '@/constants/routeName';
import basicOptions from '@/router/basic-options';
import List from '@/views/MemberCompanyInquiry/List/index.vue';
import Detail from '@/views/MemberCompanyInquiry/Detail/index.vue';
import Edit from '@/views/MemberCompanyInquiry/Edit/index.vue';
export default [
    {
        path: 'member-company-inquiry',
        name: routeName.MEMBER_COMPANY_INQUIRY,
        component: List,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    /** 작성 */
    {
        path: 'member-company-inquiry/create',
        name: routeName.MEMBER_COMPANY_INQUIRY_CREATE,
        component: Edit,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    /** 수정 */
    {
        path: 'member-company-inquiry/:itemId/edit',
        name: routeName.MEMBER_COMPANY_INQUIRY_EDIT,
        component: Edit,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    /** 상세조회 및 댓글 리스트 */
    {
        path: 'member-company-inquiry/:memberCompanyInquiryId/detail',
        name: routeName.MEMBER_COMPANY_INQUIRY_DETAIL,
        component: Detail,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
];
